var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNireland(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5 -1H-9.5V17H26.5V-1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6H0.5V10H16.5V6Z",
    fill: "#CC0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 16L10.5 0L6.5 -1.74846e-07L6.5 16L10.5 16Z",
    fill: "#CC0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.78564 3.28561V4.42847H10.2142V3.28561H9.9285L9.64279 2.71418L9.07136 3.28561L8.49993 2.42847L7.9285 3.28561L7.35707 2.71418L7.07136 3.28561H6.78564Z",
    fill: "#F5D136"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2142 4.42885C10.2142 4.74444 9.4467 5.00028 8.49993 5.00028C7.55316 5.00028 6.78564 4.74444 6.78564 4.42885C6.78564 4.11326 7.55316 3.85742 8.49993 3.85742C9.4467 3.85742 10.2142 4.11326 10.2142 4.42885Z",
    fill: "#D9D9D9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.85725L9.57633 1.66889C9.91442 1.60972 10.2555 1.75587 10.4459 2.04146V2.04146C10.6496 2.34688 10.6384 2.7475 10.4182 3.04116L9.80612 3.85725",
    stroke: "#F5D136",
    strokeWidth: 0.285714
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.57153V3.85725",
    stroke: "#F5D136",
    strokeWidth: 0.285714
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.85725L7.42367 1.66889C7.08558 1.60972 6.74445 1.75587 6.55406 2.04146V2.04146C6.35045 2.34688 6.36157 2.7475 6.58181 3.04116L7.19388 3.85725",
    stroke: "#F5D136",
    strokeWidth: 0.285714
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07108 1.7619C9.07108 1.55984 9.01088 1.36604 8.90371 1.22316C8.79655 1.08027 8.6512 1 8.49965 1C8.3481 1 8.20275 1.08027 8.09559 1.22316C7.98843 1.36604 7.92822 1.55983 7.92822 1.7619L8.49965 2.14286L9.07108 1.7619Z",
    fill: "#F5D136"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 12L7.28756 10H4.5L6.07513 8L4.5 6H7.28756L8.5 4L9.71244 6H12.5L10.9249 8L12.5 10H9.71244L8.5 12Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05907 9.31431C9.17647 9.12946 9.9679 7.59633 9.57954 7.59633C9.36613 7.59633 9.1215 8.27272 9.1215 8.27272C9.15097 8.0189 9.17779 6.24187 8.84458 6.23708C8.65491 6.23435 8.71963 7.50232 8.70233 7.61215C8.70233 7.45706 8.73322 6 8.46519 6C8.18075 6 8.30583 7.38074 8.27559 7.61215C8.26853 7.50132 8.31342 6.20198 8.13463 6.20198C7.84743 6.20198 7.93796 7.40495 7.94367 7.61215C7.94367 7.45706 7.94644 6.56879 7.78521 6.58189C7.50425 6.60472 7.47139 8.44929 7.5169 8.6553C7.5169 8.98722 7.77043 9.07356 7.77043 9.31431C7.76163 9.47803 7.77043 10 7.77043 10H9.05907C9.05907 10 9.05907 9.46138 9.05907 9.31431Z",
    fill: "#CC0000",
    stroke: "white",
    strokeWidth: 0.06
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNireland);
export default __webpack_public_path__ + "static/media/nireland.190593eee8d8e6e75035d3f63a35516b.svg";
export { ForwardRef as ReactComponent };